import { useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { useAuth } from "../context/AuthContext"

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false)
  const { user, logout } = useAuth()
  const location = useLocation()

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen)
  }

  const handleLogout = () => {
    logout()
    setIsProfileMenuOpen(false)
  }

  return (
    <nav className="bg-gradient-to-r from-spiritual-600 to-spiritual-800 text-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <Link to="/" className="flex items-center">
            <div className="w-10 h-10 bg-divine-400 rounded-full flex items-center justify-center">
              <span className="text-spiritual-800 font-bold text-xl">D</span>
            </div>
            <span className="text-2xl font-bold ml-2">DivyaTemple</span>
          </Link>
        </div>

        <div className="hidden md:flex space-x-8 text-lg">
          <Link
            to="/"
            className={`hover:text-divine-300 transition-colors ${location.pathname === "/" ? "text-divine-300" : ""}`}
          >
            Home
          </Link>
          <Link
            to="/temple"
            className={`hover:text-divine-300 transition-colors ${location.pathname === "/temple" ? "text-divine-300" : ""
              }`}
          >
            Temples
          </Link>
          <Link
            to="/about"
            className={`hover:text-divine-300 transition-colors ${location.pathname === "/about" ? "text-divine-300" : ""
              }`}
          >
            About
          </Link>
          <Link
            to="/contact"
            className={`hover:text-divine-300 transition-colors ${location.pathname === "/contact" ? "text-divine-300" : ""
              }`}
          >
            Contact
          </Link>

          <div className="border-l border-spiritual-400 mx-2"></div>

          {user ? (
            <div className="relative">
              <button onClick={toggleProfileMenu} className="flex items-center hover:text-divine-300 transition-colors">
                <span className="mr-1">{user.name}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`h-4 w-4 transition-transform ${isProfileMenuOpen ? "rotate-180" : ""}`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {isProfileMenuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
                  <Link
                    to="/profile"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => setIsProfileMenuOpen(false)}
                  >
                    Profile
                  </Link>
                  {
                    user && !user.isAdmin &&
                    <Link
                      to="/favorites"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      onClick={() => setIsProfileMenuOpen(false)}
                    >
                      Favorites
                    </Link>
                  }
                  {user.isAdmin && (
                    <Link
                      to="/admin/dashboard"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      onClick={() => setIsProfileMenuOpen(false)}
                    >
                      Admin Dashboard
                    </Link>
                  )}
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <>
              <Link
                to="/login"
                className={`hover:text-divine-300 transition-colors ${location.pathname === "/login" ? "text-divine-300" : ""
                  }`}
              >
                Login
              </Link>
              <Link
                to="/signup"
                className={`hover:text-divine-300 transition-colors font-medium ${location.pathname === "/signup" ? "text-divine-300" : ""
                  }`}
              >
                Sign Up
              </Link>
            </>
          )}
        </div>

        <button onClick={toggleMenu} className="md:hidden text-2xl">
          ☰
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-spiritual-700 px-4 py-2">
          <div className="flex flex-col space-y-3">
            <Link
              to="/"
              className={`hover:text-divine-300 transition-colors ${location.pathname === "/" ? "text-divine-300" : ""
                }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/temple"
              className={`hover:text-divine-300 transition-colors ${location.pathname === "/temple" ? "text-divine-300" : ""
                }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Temples
            </Link>
            <Link
              to="/pilgrimage"
              className={`hover:text-divine-300 transition-colors ${location.pathname === "/pilgrimage" ? "text-divine-300" : ""
                }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Pilgrimage
            </Link>
            <Link
              to="/about"
              className={`hover:text-divine-300 transition-colors ${location.pathname === "/about" ? "text-divine-300" : ""
                }`}
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            <Link
              to="/contact"
              className={`hover:text-divine-300 transition-colors ${location.pathname === "/contact" ? "text-divine-300" : ""
                }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>

            <div className="border-t border-spiritual-500 my-2 pt-2"></div>

            {user ? (
              <>
                <Link
                  to="/profile"
                  className="hover:text-divine-300 transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Profile
                </Link>
                {
                  user && !user.isAdmin &&
                  <Link
                    to="/favorites"
                    className="hover:text-divine-300 transition-colors"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Favorites
                  </Link>
                }

                {user.isAdmin && (
                  <Link
                    to="/admin/dashboard"
                    className="hover:text-divine-300 transition-colors"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Admin Dashboard
                  </Link>
                )}
                <button
                  onClick={() => {
                    handleLogout()
                    setIsMenuOpen(false)
                  }}
                  className="text-left hover:text-divine-300 transition-colors"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className={`hover:text-divine-300 transition-colors ${location.pathname === "/login" ? "text-divine-300" : ""
                    }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className={`hover:text-divine-300 transition-colors font-medium ${location.pathname === "/signup" ? "text-divine-300" : ""
                    }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  )
}

export default Navbar
